import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Lock, AlertCircle, Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { Input } from "@/components/ui/input";

const formatError = (detail) => {
  if (!detail) return "No se pudo iniciar sesión. Intenta de nuevo.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  return String(detail);
};

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate(location.state?.from || "/admin", { replace: true });
    } catch (err) {
      setError(formatError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0A0A0A] flex items-center justify-center px-6">
      <div className="w-full max-w-sm">
        <div className="flex flex-col items-center mb-8">
          <div className="w-12 h-12 rounded-full bg-brand-red/10 border border-brand-red/30 flex items-center justify-center mb-4">
            <Lock className="w-5 h-5 text-brand-red" />
          </div>
          <h1 className="text-white font-heading text-xl font-bold">Panel Administrativo</h1>
          <p className="text-neutral-500 text-sm mt-1">Doble R Records Distribution</p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4" data-testid="admin-login-form">
          <div>
            <label className="text-neutral-400 text-xs font-medium mb-1.5 block">Correo electrónico</label>
            <Input
              data-testid="admin-login-email"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="bg-white/[0.03] border-white/10 text-white h-11"
              placeholder="tu@correo.com"
            />
          </div>
          <div>
            <label className="text-neutral-400 text-xs font-medium mb-1.5 block">Contraseña</label>
            <Input
              data-testid="admin-login-password"
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="bg-white/[0.03] border-white/10 text-white h-11"
              placeholder="••••••••"
            />
          </div>

          {error && (
            <div data-testid="admin-login-error" className="flex items-start gap-2 rounded-lg border border-brand-red/30 bg-brand-red/[0.06] p-3">
              <AlertCircle className="w-4 h-4 text-brand-red shrink-0 mt-0.5" />
              <p className="text-neutral-300 text-xs leading-relaxed">{error}</p>
            </div>
          )}

          <button
            type="submit"
            disabled={loading}
            data-testid="admin-login-submit"
            className="w-full h-11 rounded-full bg-brand-red text-white font-bold text-sm flex items-center justify-center gap-2 hover:bg-brand-red/90 transition-colors disabled:opacity-60"
          >
            {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Iniciar sesión"}
          </button>
        </form>
      </div>
    </div>
  );
}
